export default "__VITE_ASSET__Dg_Pg6Jf__"